import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { useGetQuestionList } from '@/query/queries/question/useGetQuestionList';
import { QuestionCard } from '../card';
import s from './index.module.scss';

export const QuestionsList = () => {
  const { t } = useTranslation('client_questions');
  const { data, hasNextPage, fetchNextPage, isFetchingNextPage } = useGetQuestionList();

  return (
    <>
      <div className={s.list}>
        {data?.pages.map(page =>
          page.list.map(question => (
            <div key={question.id} className={s.list_item}>
              <QuestionCard question={question} />
            </div>
          )),
        )}
      </div>

      {hasNextPage && (
        <div style={{ textAlign: 'center' }}>
          <button
            type="button"
            className={classnames(s.btn_more, 'f-20 f-500')}
            onClick={fetchNextPage}
            disabled={isFetchingNextPage}
          >
            {t('load_more')}
          </button>
        </div>
      )}
    </>
  );
};
